import { App as CapacitorApp } from '@capacitor/app';

export const setupNativeBackButtonAction = () => {
    CapacitorApp.addListener('backButton', ({ canGoBack }) => {
        // Exit app if there is no history to go back to
        if (!canGoBack){
            CapacitorApp.exitApp();
        } else {
            window.history.back();
        }
    });
}
